import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Row, Col, Button, Table, Alert, Spinner } from "react-bootstrap";

const PostGST2bData = () => {
  const user = useSelector((state) => state.user?.currentUser);
  const token = user?.token;

  const [pendingBatches, setPendingBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [posting, setPosting] = useState(false);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // =======================================
  // Load Pending Batches on Page Load
  // =======================================
  const loadPendingBatches = async () => {
    try {
      setLoading(true);
      setErrorMsg("");
      setSuccessMsg("");

      const res = await axios.get("/api/gst2b/getPendingBatches", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setPendingBatches(res.data || []);
    } catch (err) {
      console.error("Error loading pending batches", err);
      setErrorMsg("Failed to load pending batches");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPendingBatches();
  }, []);

  // =======================================
  // POST GST2B → Call Backend Procedure
  // =======================================
  const postGST2b = async (batch) => {
    try {
      setPosting(true);
      setErrorMsg("");
      setSuccessMsg("");

      const payload = {
        batch_no: batch.BATCH_NO,
        period: batch.PERIOD,
        entity_code: batch.ENTITY_CODE,
        fy: batch.FY,
        posted_by: user?.emp_id,
      };

      const res = await axios.post(
        "/api/gst2b/postFromStage",
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setSuccessMsg(res.data?.message || "GST2B Posted Successfully!");

      // Refresh grid
      loadPendingBatches();
    } catch (err) {
      console.error("Post GST2B Error:", err);
      setErrorMsg(
        err.response?.data?.message || "Failed to post GST2B data"
      );
    } finally {
      setPosting(false);
    }
  };

  return (
    <div className="container mt-3">

      <h4 className="text-primary">Post GST-2B Data</h4>

      {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
      {successMsg && <Alert variant="success">{successMsg}</Alert>}

      {loading ? (
        <div className="text-center mt-3">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <h5 className="mt-3">Pending Batches</h5>

          {pendingBatches.length === 0 ? (
            <Alert variant="info">No pending batches to post.</Alert>
          ) : (
            <Table bordered hover responsive size="sm" className="mt-2">
              <thead>
                <tr>
                  <th>Batch No</th>
                  <th>Period</th>
                  <th>Entity</th>
                  <th>FY</th>
                  <th>Uploaded By</th>
                  <th>Uploaded On</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {pendingBatches.map((b, idx) => (
                  <tr key={idx}>
                    <td>{b.BATCH_NO}</td>
                    <td>{b.PERIOD}</td>
                    <td>{b.ENTITY_CODE}</td>
                    <td>{b.FY}</td>
                    <td>{b.UPLOADED_BY}</td>
                    <td>{b.UPLOADED_ON}</td>
                    <td>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => postGST2b(b)}
                        disabled={posting}
                      >
                        {posting ? (
                          <Spinner size="sm" />
                        ) : (
                          "POST GST2B"
                        )}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </>
      )}
    </div>
  );
};

export default PostGST2bData;
